import { render, staticRenderFns } from "./Moments.vue?vue&type=template&id=be285768&scoped=true&"
import script from "./Moments.vue?vue&type=script&lang=js&"
export * from "./Moments.vue?vue&type=script&lang=js&"
import style0 from "./Moments.vue?vue&type=style&index=0&id=be285768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be285768",
  null
  
)

export default component.exports